export { FeaturedNewsCard } from "./FeaturedNewsCard";
